import React,{ useState, useEffect } from 'react';

import Fig1 from '../../images/hardware-setup/router-setup-figure-one.jpg';
import Fig2 from '../../images/hardware-setup/router-setup-figure-two.png';
import Fig3 from '../../images/hardware-setup/router-setup-figure-three.png';
import Fig4 from '../../images/hardware-setup/router-setup-figure-four.png';

function RouterSetup() {

    return (
        <div id="router-setup-component" className="modem-setup-component modem-connectivity-component">
            <h2>Mercku M6 Router Set Up</h2>
            <h4>Port Configuration</h4>
            <img style={{ maxWidth: '225px', marginBottom:'3rem' }} src={ Fig1 } />
            <h4>Set Up In 3 Steps</h4>

            <div style={{ fontWeight:600, marginTop:'2rem' }}>1. Connect provided power and WAN cables to the M6a</div>
            <p style={{ fontSize:'0.9rem' }}>Red light indicates that there is power. When the device has an internet connection, the light will turn white.</p>
            <img style={{ maxWidth: '225px' }} src={ Fig2 } />

            <div style={{ fontWeight:600, marginTop:'3rem' }}>2. Connect to Wi-Fi</div>
            <p style={{ fontSize:'0.9rem' }}>Use your mobile device or computer to search for and connect to the open MERCKU-XXXX Wi-Fi network.</p>
            <img style={{ maxWidth: '225px' }} src={ Fig3 } />

            <div style={{ fontWeight:600, marginTop:'3rem' }}>3. Complete setup via app or web browser</div>
            <p style={{ fontSize:'0.9rem' }}>
            Download the Mercku app wherever you get your applications, (<a href="https://apps.apple.com/us/app/mercku-wifi/id1397291125" target="_blank" >Apple store</a>, <a href="https://play.google.com/store/apps/details?id=com.mercku.merckuwifi&hl=en_CA" target="_blank" >Google play</a>) to complete setup and manage your network.</p><p style={{ fontSize:'0.9rem' }}>Watch this <a href="https://www.youtube.com/watch?v=P408jwyzSos" target="_blank" >handy video</a> to view setup options and procedures in more detail.</p>
        </div>
    )
}

export default RouterSetup